import { HasKind } from '@/utilities/HasKind';

export const kind = 'DestroyComplete';

export type DestroyComplete = HasKind<typeof kind>;

// Singleton-ish instance for convenience.
export const destroyComplete: DestroyComplete = { kind };
